import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import initialState from "../initial-state";

interface BetBoostInit {
  action: string;
  value: number;
  rtp: number;
  tooltip: boolean;
}

export interface BetBoostType extends BetBoostInit {
  active: boolean;
}

const betBoost = createSlice({
  name: "betBoost",
  initialState: initialState.betBoost,
  reducers: {
    toggleBetBoost(state, action: PayloadAction<boolean>) {
      if (state === null || state.value === 0) return state;

      return { ...state, active: action.payload };
    },

    setTooltip(state, action: PayloadAction<boolean>) {
      if (state === null || state.tooltip === action.payload) return state;
      return { ...state, tooltip: action.payload };
    },

    initBetBoost(_, action: PayloadAction<BetBoostInit>) {
      return { ...action.payload, active: false };
    },
  },
});

export const { toggleBetBoost, initBetBoost, setTooltip } = betBoost.actions;

export default betBoost;
